import React from 'react'

const SvgChat = props => (
	<svg width={45.242} height={45.242} {...props}>
		<path d='M0 0h45.242v45.242H0z' data-name='Ret\xE2ngulo 1688' fill='none' />
		<path
			d='M16.966 5.655v5.655H0v28.277h3.412l5.658-5.656h19.206v-5.655h7.894l5.655 5.655h3.417V5.655zm8.483 25.449H7.893l-5.065 5.065V14.138h22.621zm16.966-.587l-5.07-5.069h-9.07V11.31h-8.482V8.483h22.622z'
			data-name='Caminho 430'
			fill={props.color || '#0088c8'}
		/>
	</svg>
)

export default SvgChat
